// extracted by mini-css-extract-plugin
export default {"linksSection":"LinksSection-module--linksSection--98p1L"};